import { banco } from '../db/banco'
import type { Produto, RegraComissao } from '../db/tipos'

// Quais tabelas uma regra governa (B5.1 da spec): a regra de uma tabela governa
// aquela tabela; a regra padrao da marca governa as que nao tem regra propria.
async function tabelasGovernadas(representadaId: string, regra: RegraComissao): Promise<string[]> {
  if (regra.tabela_preco_id !== null) return [regra.tabela_preco_id]
  const tabelas = await banco.tabelas_preco
    .where('representada_id').equals(representadaId)
    .filter((t) => t.apagado_em === null)
    .toArray()
  const regras = await banco.regras_comissao
    .where('representada_id').equals(representadaId)
    .filter((r) => r.apagado_em === null)
    .toArray()
  const comRegraPropria = new Set(
    regras
      .filter((r) => r.tabela_preco_id !== null)
      .map((r) => r.tabela_preco_id as string),
  )
  return tabelas.filter((t) => !comRegraPropria.has(t.id)).map((t) => t.id)
}

export async function produtosComPrecoNaRegra(
  representadaId: string,
  regra: RegraComissao,
): Promise<Produto[]> {
  const tabelas = await tabelasGovernadas(representadaId, regra)
  const idsComPreco = new Set<string>()
  for (const tabelaId of tabelas) {
    const precos = await banco.precos
      .where('tabela_preco_id').equals(tabelaId)
      .filter((p) => p.apagado_em === null)
      .toArray()
    for (const preco of precos) idsComPreco.add(preco.produto_id)
  }
  const produtos = await banco.produtos
    .where('representada_id').equals(representadaId)
    .filter((p) => p.apagado_em === null && p.ativo)
    .toArray()
  return produtos.filter((p) => idsComPreco.has(p.id))
}

// Os produtos vendaveis por UMA tabela. Diferente de produtosComPrecoNaRegra:
// quando a regra governante e a padrao da marca, ela abrange varias tabelas, e a
// tela de precos so pode cobrar comissao dos produtos da tabela aberta.
export async function produtosComPrecoNaTabela(
  representadaId: string,
  tabelaId: string,
): Promise<Produto[]> {
  const precos = await banco.precos
    .where('tabela_preco_id').equals(tabelaId)
    .filter((p) => p.apagado_em === null)
    .toArray()
  const idsComPreco = new Set(precos.map((p) => p.produto_id))
  const produtos = await banco.produtos
    .where('representada_id').equals(representadaId)
    .filter((p) => p.apagado_em === null && p.ativo)
    .toArray()
  return produtos.filter((p) => idsComPreco.has(p.id))
}
